<template>
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.99996 1.60428C9.98021 1.60428 12.3958 4.02045 12.3958 7.00011C12.3958 9.97978 9.98021 12.3959 6.99996 12.3959C4.02029 12.3959 1.60413 9.97978 1.60413 7.00011C1.60413 4.02045 4.02029 1.60428 6.99996 1.60428Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M6.99707 4.78583V7.36358"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M6.99707 9.21439H7.0029"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
